var React = require('react');

function Uav (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.2784,4.6545L3.7722,5.1482A2.69,2.69,0,1,1,5.144,3.7869l-0.49-.49A2.0591,2.0591,0,1,0,3.2784,4.6545Zm6.58-.87L10.35,3.2929a2.0589,2.0589,0,1,1,1.367,1.3658l-0.4921.4918A2.6879,2.6879,0,1,0,9.8585,3.7847ZM5.1419,11.2309L4.65,11.7227a2.0589,2.0589,0,1,1-1.3667-1.3664l0.492-.4918A2.6878,2.6878,0,1,0,5.1419,11.2309Zm9.0716-.8155a2.6894,2.6894,0,0,0-2.9888-.5507l0.492,0.4917A2.0571,2.0571,0,1,1,10.35,11.7227l-0.4921-.4918A2.6863,2.6863,0,1,0,14.2134,10.4154Zm-2.644,2.62a1.0311,1.0311,0,1,0,.3583-1.6875l-1.6813-1.68A3.1859,3.1859,0,0,1,10.24,5.3534l1.6731-1.6722a1.0306,1.0306,0,1,0-.5852-0.5849L9.6613,4.7624a3.19,3.19,0,0,1-4.3164.0061L3.6874,3.1118a1.0376,1.0376,0,1,0-.5956.5745L4.7535,5.3473a3.1875,3.1875,0,0,1,.0031,4.3172L3.0943,11.326a1.0306,1.0306,0,1,0,.5852.5849l1.6623-1.6615a3.19,3.19,0,0,1,4.3133-.0031l1.6854,1.6845A1.0291,1.0291,0,0,0,11.5694,13.0355Z"}));
}

Uav.defaultProps = {"viewBox":"0 0 15 15"};

module.exports = Uav;

Uav.default = Uav;



//////////////////
// WEBPACK FOOTER
// ../assets/icons/uav.svg
// module id = 912
// module chunks = 9